import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
    MatToolbarModule,
    MatButtonModule,
    MAT_DIALOG_DEFAULT_OPTIONS,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule } from '@angular/material';

import { DialogModule } from './dialog.module';

import { ResetPasswordComponent } from '../auth/reset-password/reset-password.component';

const imports = [
    MatToolbarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    DialogModule
];

const exps = [
    ResetPasswordComponent
];

const declarations = [
    ResetPasswordComponent,
];

@NgModule({
    imports: [...imports],
    exports: [...exps],
    declarations: [...declarations]
})
export class ResetModule { }
